import { Card, Badge } from '../../design-system';
import { cn } from '../../utils/cn';

export default function DecisionCardComponent({ card, onUpdate, onClick }) {
  const hasContent = card.gallery?.length > 0 || card.selectedOption || card.textValue || card.comments?.length > 0;

  // Map status to badge variant
  const getStatusVariant = () => {
    if (card.status === 'decided') return 'success';
    if (card.status === 'in-discussion') return 'primary';
    if (card.status === 'later') return 'default';
    return 'warning';
  };

  return (
    <Card
      hover
      onClick={onClick}
      className={cn(
        'p-6 border-2',
        hasContent ? 'border-primary/50' : 'border-border',
        'hover:border-primary'
      )}
    >
      {/* Card header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-bold text-lg text-text-primary mb-1">
            {card.title}
          </h3>
          {card.description && (
            <p className="text-sm text-text-secondary">
              {card.description}
            </p>
          )}
        </div>
        
        {/* Status badge */}
        <Badge variant={getStatusVariant()}>
          {card.status === 'to-discuss' ? 'To Discuss' :
           card.status === 'in-discussion' ? 'Discussing' :
           card.status === 'decided' ? 'Decided' :
           'Later'}
        </Badge>
      </div>

      {/* Preview of content */}
      {card.type === 'gallery' && card.gallery?.length > 0 && (
        <div className="grid grid-cols-3 gap-2 mb-3">
          {card.gallery.slice(0, 3).map((item, i) => (
            <div key={i} className="aspect-square rounded-lg overflow-hidden bg-gray-100">
              <img src={item.thumbnail || item.url} alt="" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      )}

      {card.type === 'options' && card.selectedOption && (
        <div className="mb-3">
          <Badge variant="primary" size="lg">
            {card.selectedOption}
          </Badge>
        </div>
      )}

      {card.type === 'text' && card.textValue && (
        <div className="mb-3">
          <p className="text-sm text-text-secondary line-clamp-2">
            {card.textValue}
          </p>
        </div>
      )}

      {/* Action hint */}
      <div className="flex items-center justify-between text-sm">
        <span className="text-text-secondary">
          {card.comments?.length > 0 ? `${card.comments.length} comments` : 'No comments yet'}
        </span>
        
        {card.custom && (
          <Badge variant="primary" size="sm">
            Custom
          </Badge>
        )}
      </div>

      {/* Dismiss button */}
      {!card.required && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (window.confirm('Dismiss this decision card?')) {
              onUpdate({ status: 'dismissed' });
            }
          }}
          className="mt-3 w-full text-sm text-text-secondary hover:text-red-600 transition-colors"
        >
          Dismiss
        </button>
      )}
    </Card>
  );
}
